import { render, staticRenderFns } from "./ReturnWithdrawReason.vue?vue&type=template&id=e2faccb4&"
import script from "./ReturnWithdrawReason.vue?vue&type=script&lang=ts&"
export * from "./ReturnWithdrawReason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports